import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = {
  key: 0,
  class: "p-field"
}
const _hoisted_4 = { class: "p-field-label mb-3" }
const _hoisted_5 = {
  for: "gateName",
  class: "fs-13 label-error"
}
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "p-field-label mb-3" }
const _hoisted_8 = { class: "d-flex mb-4" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "p-field-label mt-1",
  for: "scsAddr"
}
const _hoisted_11 = {
  for: "scsAddr",
  class: "fs-13 label-error"
}
const _hoisted_12 = {
  key: 0,
  class: "p-field"
}
const _hoisted_13 = { class: "p-field-label" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "p-field-label" }
const _hoisted_16 = { class: "p-field-label mt-5 mb-3" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "mt-4 mb-3 secondary-label fw-normal fs-12 text-uppercase" }
const _hoisted_20 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ButtonSelection = _resolveComponent("ButtonSelection")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isDialogVisible = $event)),
    showHeader: false,
    modal: true,
    onHide: _ctx.doHideDialog,
    class: "dialog-custom"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", {
        class: ["dialog-custom__content form-custom", _ctx.onlyDevices ? 'devices-only' : 'gate-config']
      }, [
        _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
          default: _withCtx(() => [
            (!_ctx.onlyDevices)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.Name")), 1),
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.currentGate.gateName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentGate.gateName = $event)),
                    id: "gateName",
                    type: "text",
                    class: ["w-50", { 'input-error': !_ctx.isValidName }]
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("div", null, [
                    _createVNode("label", _hoisted_5, _toDisplayString(_ctx.invalidNameReason), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_6, [
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("SelectDevicesInGate")), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_ButtonSelection, {
                class: "ml-1 mr-4",
                icon: require(`@/assets/images/entrancePlants/icon-new-pe.svg`),
                label: _ctx.$t('AppResourceEP.NewPeDevice'),
                modelValue: _ctx.currentGate.newPeSelected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentGate.newPeSelected = $event)),
                disabled: _ctx.newPeDisabled || (_ctx.currentEntrancePlant.syncStatus?.isPlantActive && _ctx.isEdit)
              }, null, 8, ["icon", "label", "modelValue", "disabled"]),
              _createVNode(_component_ButtonSelection, {
                class: "mr-4",
                icon: require(`@/assets/images/entrancePlants/icon-keypad.svg`),
                label: _ctx.$t('AppResourceEP.KeyPad'),
                modelValue: _ctx.currentGate.keypadSelected,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentGate.keypadSelected = $event)),
                disabled: _ctx.keypadDisabled || (_ctx.currentEntrancePlant.syncStatus?.isPlantActive && _ctx.isEdit)
              }, null, 8, ["icon", "label", "modelValue", "disabled"]),
              _createVNode(_component_ButtonSelection, {
                class: "mr-4",
                icon: require(`@/assets/images/entrancePlants/icon-smart-reader.svg`) ,
                label: _ctx.$t('AppResourceEP.SmartReader'),
                modelValue: _ctx.currentGate.smartReaderSelected,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentGate.smartReaderSelected = $event)),
                disabled: _ctx.smartReaderDisabled || (_ctx.currentEntrancePlant.syncStatus?.isPlantActive && _ctx.isEdit)
              }, null, 8, ["icon", "label", "modelValue", "disabled"])
            ]),
            (!_ctx.onlyDevices)
              ? (_openBlock(), _createBlock("span", _hoisted_9, [
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.DeviceScsAddress")), 1),
                  _createVNode(_component_InputText, {
                    id: "scsAddr",
                    type: "number",
                    class: ["w-50", { 'input-error': !_ctx.isValidScs }],
                    min: _ctx.MIN_SCS_ADDRESS,
                    max: _ctx.MAX_SCS_ADDRESS,
                    modelValue: _ctx.currentGate.scsAddress,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentGate.scsAddress = $event))
                  }, null, 8, ["min", "max", "modelValue", "class"]),
                  _createVNode("div", null, [
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.invalidScsReason), 1)
                  ]),
                  (_ctx.currentEntrancePlant.hasRiserInterface)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        (_ctx.currentEntrancePlant.buildings)
                          ? (_openBlock(), _createBlock("div", _hoisted_12, [
                              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
                              (!_ctx.isEdit)
                                ? (_openBlock(), _createBlock(_component_Dropdown, {
                                    key: 0,
                                    class: "w-50",
                                    options: _ctx.currentEntrancePlant.buildings,
                                    disabled: _ctx.currentEntrancePlant.buildings.length === 1,
                                    optionLabel: "name",
                                    modelValue: _ctx.selectedBuilding,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedBuilding = $event))
                                  }, null, 8, ["options", "disabled", "modelValue"]))
                                : (_openBlock(), _createBlock(_component_InputText, {
                                    key: 1,
                                    class: "w-50",
                                    value: _ctx.getBuildingName(_ctx.currentGate),
                                    disabled: ""
                                  }, null, 8, ["value"]))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_14, [
                          _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                          (!_ctx.isEdit)
                            ? (_openBlock(), _createBlock(_component_Dropdown, {
                                key: 0,
                                class: "w-50",
                                options: _ctx.buildingRisers,
                                disabled: _ctx.buildingRisers.length === 1,
                                optionLabel: "name",
                                optionValue: "riserInterfaceId",
                                modelValue: _ctx.currentGate.connectedRiserInterfaceId,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentGate.connectedRiserInterfaceId = $event))
                              }, null, 8, ["options", "disabled", "modelValue"]))
                            : (_openBlock(), _createBlock(_component_InputText, {
                                key: 1,
                                class: "w-50",
                                value: _ctx.getRiserName(_ctx.currentGate),
                                disabled: ""
                              }, null, 8, ["value"]))
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.SetupDefineGatesBuildingGovern")), 1),
                        (_ctx.currentEntrancePlant.buildings )
                          ? (_openBlock(), _createBlock("div", _hoisted_17, [
                              _createVNode(_component_ListItemCheck, {
                                label: _ctx.$t('AppResource.All'),
                                inputId: "AllBuilding",
                                name: "building",
                                modelValue: _ctx.allBuildings,
                                "onUpdate:modelValue": [
                                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.allBuildings = $event)),
                                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleUpdateBuildingSelection(_ctx.AllBuildingsValue)))
                                ],
                                binary: ""
                              }, null, 8, ["label", "modelValue"]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.buildings, (building, i) => {
                                return (_openBlock(), _createBlock(_component_ListItemCheck, {
                                  key: i,
                                  last: i == _ctx.currentEntrancePlant.buildings.length - 1,
                                  label: building.name,
                                  value: building.buildingId,
                                  inputId: 'building' + i,
                                  name: "building",
                                  modelValue: _ctx.selectedBuildingIds,
                                  "onUpdate:modelValue": [
                                    _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedBuildingIds = $event)),
                                    ($event: any) => (_ctx.handleUpdateBuildingSelection('', building.buildingId))
                                  ]
                                }, null, 8, ["last", "label", "value", "inputId", "modelValue", "onUpdate:modelValue"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isBRFA)
                          ? (_openBlock(), _createBlock("div", _hoisted_18, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildings, (b) => {
                                return (_openBlock(), _createBlock(_Fragment, {
                                  key: b.buildingId
                                }, [
                                  _createVNode("div", _hoisted_19, [
                                    _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.For")) + " " + _toDisplayString(b.name) + " " + _toDisplayString(_ctx.$t("TheyManage")), 1)
                                  ]),
                                  (b && b.risers && b.buildingId)
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_ListItemCheck, {
                                          label: _ctx.$t('AppResourceEP.SetupDefineGatesBuildingAllRisers'),
                                          inputId: "AllRisers_b_{{b.buildingId}}",
                                          name: "riser",
                                          modelValue: _ctx.allRisers[b.buildingId],
                                          "onUpdate:modelValue": [($event: any) => (_ctx.allRisers[b.buildingId] = $event), ($event: any) => (_ctx.handleUpdateRiserSelection(_ctx.AllRisersValue, b.buildingId))],
                                          binary: ""
                                        }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(b.risers, (riser, i) => {
                                          return (_openBlock(), _createBlock(_component_ListItemCheck, {
                                            key: i,
                                            last: i == b.risers.length - 1,
                                            label: riser.name,
                                            value: riser.riserId,
                                            inputId: 'riser' + i,
                                            name: "riser",
                                            modelValue: _ctx.selectedRiserIds[b.buildingId],
                                            "onUpdate:modelValue": [($event: any) => (_ctx.selectedRiserIds[b.buildingId] = $event), ($event: any) => (_ctx.handleUpdateRiserSelection('',b.buildingId))]
                                          }, null, 8, ["last", "label", "value", "inputId", "modelValue", "onUpdate:modelValue"]))
                                        }), 128))
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2),
      _createVNode("footer", _hoisted_20, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: 
                    _ctx.isEdit ? _ctx.$t('AppResource.Save') : _ctx.$t('AppResource.Create')
                ,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: _ctx.saveButtonDisabled
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}